export enum BatchStatusEnum {
  InProgress = 1,
  Available = 2,
  FailedWithError = 3
}

export interface SchoolCandidateBatchStatus {
  countyId: number;
  status: BatchStatusEnum;
  batchId: number;
  processedAt: string;
  schoolYearId: number;
}
